import { fields } from './data-fields'

export default {
    fields
}
